import { contentApi } from '..';
import { apiRoutes } from '../apiRoutes';
import { ContactUsData } from './types';

export const getContactUsData = async () => {
  const response = await contentApi.get<ContactUsData>(apiRoutes.common.contactUs);
  return response?.data;
};
